import React, { FC, useState } from 'react'

import { Wrapper } from 'components/page/ForeignProfile/Field/Field.styled'
import { ParentIconBlueHashTag } from 'components/page/Interests/InterestsIcon.styled'
import { InterestsListLoadable } from 'components/page/Interests/InterestsListLoadable'
import { ShowMoreInterest } from 'components/page/Interests/ShowMoreInterest'
import { GenericMenuItemIndex } from 'components/presentational/GenericMenuItemIndex/GenericMenuItemIndex'
import { CountriesActiveSvg } from 'components/presentational/svg/CountriesActiveSvg'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'
import {
  ClientInterest,
  ListInterest,
} from 'reducers/interests/interests.types'

import { CountryList } from './Countries.types'

export const CountriesView: FC<{
  countries: CountryList
}> = ({ countries }) => {
  const { javaScriptEnabled } = useShallowEqualSelector(
    ({ systemReducer: { javaScriptEnabled } }) => ({
      javaScriptEnabled,
    })
  )

  const [isShowAll, setShowAll] = useState(!javaScriptEnabled)
  return (
    <Wrapper>
      <GenericMenuItemIndex
        data-name="profile-countries"
        hideArrow={true}
        active={true}
        label={false}
        iconItem={
          <ParentIconBlueHashTag>
            <CountriesActiveSvg />
          </ParentIconBlueHashTag>
        }
        style={{ padding: '10px 0 0 0' }}
      >
        <InterestsListLoadable
          items={countries as unknown as ClientInterest[]}
          allHighlighted={false}
          isShowAllInterest={isShowAll}
          horizontalAlignment="flex-start"
          numberColumnToShow={4}
          showMore={
            <ShowMoreInterest
              onClick={() => setShowAll(true)}
              size={countries?.length}
            />
          }
          type={ListInterest.countries}
        />
      </GenericMenuItemIndex>
    </Wrapper>
  )
}
